import * as React from "react";
import { Link } from "react-router-dom";

import "./Success.css";

const ReturnLink = () =>
  <Link className="order-success__return-link success-green" to="/">
    Về trang chủ >
  </Link>;

export default ReturnLink;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/ReturnLink.tsx